import AvatarIcon from "@/assets/SVG/avatarIcon";
import { Box, Popover, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getTokenUser, removeTokenUser, setToken } from "../api/token";
import { logout } from "../api/user";
import LogoutIcon from "../assets/SVG/logoutIcon";
import userProfileDefault from "../assets/image/user-profile3.png";

export default function Logoutpop({ openPopover, setOpenPopover, pic, name }) {
  const navigate = useNavigate();

  const [anchorEl, setAnchorEl] = useState(null);
  const handleClose = () => {
    setAnchorEl(null);
    setOpenPopover(false);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  useEffect(() => {
    if (openPopover) {
      setAnchorEl(openPopover);
    }
    if (openPopover === true) {
      setAnchorEl(openPopover);
    }
  }, [openPopover]);
  return (
    <Popover
      sx={{
        "& .MuiPaper-root": {
          width: "264px",
          padding: "22px 23px",
          borderRadius: "13px",
          ml: "-10px",
          mt: "20px",
        },
        "& .MuiBackdrop-root": {
          backgroundColor: "#00000060",
        },
      }}
      id={id}
      open={open}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
    >
      <Box style={{ margin: "auto", width: "fit-content" }}>
        <img width={"100px"} src={pic ?? userProfileDefault} />
      </Box>
      <Typography textAlign={"center"}>{name}</Typography>
      <Box
        onClick={handleClose}
        sx={{ cursor: "pointer" }}
        display="flex"
        mt="25px"
      >
        <AvatarIcon />
        <Typography
          onClick={() => {
            handleClose();
            setTimeout(() => {
              navigate("/profile");
            }, 200);
          }}
          mr="10px"
          color="#757278"
          fontSize="16px"
        >
          {"مشاهده پروفایل"}
        </Typography>
      </Box>

      <Box
        onClick={() =>
          logout()
            .then(() => {
              if (getTokenUser()) {
                const token = getTokenUser();
                localStorage.clear();
                setToken(token);
                navigate("/");
                window.location.reload();
              } else {
                // localStorage.removeItem("my_information");
                localStorage.clear();
                navigate("/login");
              }
            })
            .catch(() => {})
        }
        sx={{ cursor: "pointer" }}
        display="flex"
        mt="10px"
      >
        <LogoutIcon />
        <Typography mr="10px" color="#E24B4B" fontSize="16px">
          {"خروج از حساب کاربری"}
        </Typography>
      </Box>
    </Popover>
  );
}
